import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Form, message, Typography, Space, Divider } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Title } = Typography;
const { TextArea } = Input;

const AdminAffiliate = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);

  const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
  };

  const fetchAffiliateData = async () => {
    try {
      setFetchLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/affiliate`);
      const data = response.data;
      
      form.setFieldsValue({
        mainHeading: data.mainHeading,
        cards: data.cards
      });
    } catch (error) {
      message.error('Failed to fetch affiliate data');
      console.error('Error:', error);
    } finally {
      setFetchLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/affiliate`,
        values,
        getAuthHeader()
      );
      message.success('Affiliate content updated successfully!');
    } catch (error) {
      message.error('Failed to update affiliate content');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAffiliateData();
  }, []);

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Card>
        <div style={{ marginBottom: '24px', textAlign: 'center' }}>
          <Title level={2}>Manage Affiliate Program Content</Title>
          <Button 
            icon={<ReloadOutlined />} 
            onClick={fetchAffiliateData}
            loading={fetchLoading}
          >
            Refresh Data
          </Button>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          loading={fetchLoading}
        >
          <Card title="Main Heading" style={{ marginBottom: '24px' }}>
            <Form.Item
              name="mainHeading"
              label="Main Heading Text"
              rules={[{ required: true, message: 'Please enter main heading' }]}
            >
              <TextArea 
                rows={3}
                placeholder="Enter the main heading for affiliate program"
              />
            </Form.Item>
          </Card>

          <Card title="Content Cards">
            <Form.List name="cards">
              {(fields) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Card 
                      key={key}
                      type="inner" 
                      title={`Card ${name + 1}`}
                      style={{ marginBottom: '16px' }}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'title']}
                        label="Card Title"
                        rules={[{ required: true, message: 'Please enter card title' }]}
                      >
                        <Input placeholder="Enter card title" />
                      </Form.Item>
                      
                      <Form.Item
                        {...restField}
                        name={[name, 'content']}
                        label="Card Content"
                        rules={[{ required: true, message: 'Please enter card content' }]}
                      >
                        <TextArea 
                          rows={6}
                          placeholder="Enter card content (use \n for line breaks)"
                        />
                      </Form.Item>
                    </Card>
                  ))}
                </>
              )}
            </Form.List>
          </Card>

          <Divider />

          <div style={{ textAlign: 'center' }}>
            <Space>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                icon={<SaveOutlined />}
                size="large"
              >
                Save Changes
              </Button>
            </Space>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default AdminAffiliate;